import { render, staticRenderFns } from "./SearchReports.vue?vue&type=template&id=65a88fc4&scoped=true"
import script from "./SearchReports.vue?vue&type=script&lang=ts"
export * from "./SearchReports.vue?vue&type=script&lang=ts"
import style0 from "./SearchReports.vue?vue&type=style&index=0&id=65a88fc4&prod&scoped=true&lang=css"
import style1 from "./SearchReports.vue?vue&type=style&index=1&id=65a88fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a88fc4",
  null
  
)

export default component.exports